/* eslint-disable object-shorthand */
import { Swiper, Pagination, Navigation, Thumbs } from 'swiper';

Swiper.use([Pagination, Navigation, Thumbs]);

function initImageVideoCarousel() {
  const thumbsSwiper = new Swiper('.image-video-carousel-thumbs', {
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
  });
  const swiper = new Swiper('.image-video-carousel-slider', {
    spaceBetween: 10,
    navigation: {
      nextEl: '.main-slider .swiper-button-next',
      prevEl: '.main-slider .swiper-button-prev',
    },
    pagination: {
      el: '.image-video-carousel .swiper-pagination',
      clickable: true,
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initImageVideoCarousel();
});
